import { useCallback, useMemo, useState } from 'react';
import {
  CAD_FILTER_DEFS,
  countCadActiveFilters,
  getCadAppliedFilterChips,
} from '../data/cadFilterContract';
import { sanitizeCadListFilters } from '../utils/cadFilterMatch';

const emptyFilters = () => Object.fromEntries(CAD_FILTER_DEFS.map((def) => [def.field, null]));

/**
 * Estado de filtros de la lista CAD (`/#/lista/:id`).
 * Replace en cada parse (igual que share: clear + merge).
 */
export function useCadListFilters() {
  const [activeFilters, setActiveFilters] = useState(emptyFilters);

  const setFilterValue = useCallback((field, value) => {
    setActiveFilters((prev) => ({ ...prev, [field]: value }));
  }, []);

  const removeFilterChip = useCallback((chip) => {
    if (!chip?.field) return;
    setActiveFilters((prev) => {
      const current = prev[chip.field];
      if (chip.removeValue != null && Array.isArray(current)) {
        const next = current.filter((item) => item !== chip.removeValue);
        return { ...prev, [chip.field]: next.length ? next : null };
      }
      return { ...prev, [chip.field]: null };
    });
  }, []);

  const clearAllFilters = useCallback(() => {
    setActiveFilters(emptyFilters());
  }, []);

  const applyParsedFilters = useCallback((filters) => {
    setActiveFilters({
      ...emptyFilters(),
      ...sanitizeCadListFilters(filters),
    });
  }, []);

  const activeFilterCount = useMemo(
    () => countCadActiveFilters(activeFilters),
    [activeFilters],
  );

  const appliedChips = useMemo(
    () => getCadAppliedFilterChips(activeFilters),
    [activeFilters],
  );

  return {
    activeFilters,
    activeFilterCount,
    appliedChips,
    setFilterValue,
    removeFilterChip,
    clearAllFilters,
    applyParsedFilters,
  };
}
